// The weekly prize panel from design/project/App23w-WeeklyPrize: the first time a winner opens the app after the week
// is paid, once.
import { useEffect, useState } from "react";
import { api } from "../api.js";
import { go } from "../router.js";

interface Prize {
  week: string;
  board: "xp" | "volume";
  rank: number;
  score: string;
  battles: number;
  prize: string;
}

const UN = { fontFamily: "Unbounded, sans-serif", fontWeight: "900" } as const;

export function WeeklyPrize() {
  const [p, setP] = useState<Prize | null>(null);
  useEffect(() => {
    void api<{ prize: Prize | null }>("/v1/ranks/prize").then((r) => setP(r.prize)).catch(() => {});
  }, []);
  if (!p) return null;
  const close = (to?: string) => {
    void api("/v1/ranks/prize/seen", { method: "POST", body: { week: p.week } }).catch(() => {});
    setP(null);
    if (to) go(to);
  };
  return (
    <div role="dialog" aria-modal="true" style={{ position: "fixed", inset: "0", zIndex: 50, background: "rgba(11,14,20,0.8)", backdropFilter: "blur(3px)", WebkitBackdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", fontFamily: "Inter, sans-serif", color: "#FFFFFF" }}>
      <div style={{ boxSizing: "border-box", width: "100%", maxWidth: "360px", maxHeight: "100%", overflowY: "auto", padding: "26px 20px 20px", borderRadius: "26px", background: "#161B22", border: "3px solid #CCFF00", boxShadow: "0 0 60px rgba(204,255,0,0.3), 8px 8px 0 #0B0E14", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span style={{ height: "26px", padding: "0 10px", display: "flex", alignItems: "center", background: "#CCFF00", color: "#0B0E14", border: "2px solid #0B0E14", transform: "skewX(-10deg)", ...UN, fontSize: "10px", letterSpacing: "0.08em", whiteSpace: "nowrap" }}>LAST WEEK · {p.board === "xp" ? "WEEKLY XP" : "HIGH ROLLERS"}</span>
        <div style={{ marginTop: "16px", ...UN, fontSize: "60px", lineHeight: "1", color: "#CCFF00", transform: "skewX(-8deg)", textShadow: "4px 4px 0 #0B0E14, 8px 8px 0 #FF3366" }}>#{p.rank}</div>
        <span style={{ marginTop: "14px", fontSize: "14px", color: "#C9D1D9", textAlign: "center" }}>{p.board === "xp" ? `${p.score} XP` : `${p.score} USDT staked`} from {p.battles} battles</span>
        <div style={{ marginTop: "14px", width: "100%", boxSizing: "border-box", padding: "12px 14px", borderRadius: "14px", background: "rgba(204,255,0,0.08)", border: "2px solid rgba(204,255,0,0.3)", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
          <span style={{ fontSize: "13px", fontWeight: "600" }}>Added to your balance</span>
          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontWeight: "800", fontSize: "18px", color: "#CCFF00", whiteSpace: "nowrap" }}>+{p.prize} USDT</span>
        </div>
        <span style={{ marginTop: "12px", fontSize: "12px", color: "#8B949E", textAlign: "center" }}>A new week has started. Everyone is back to 0.</span>
        <button onClick={() => close()} style={{ marginTop: "18px", width: "100%", height: "54px", border: "2px solid #0B0E14", borderRadius: "16px", background: "#CCFF00", color: "#0B0E14", ...UN, fontSize: "15px", boxShadow: "0 5px 0 #5E7500, 0 5px 0 2px #0B0E14", cursor: "pointer" }}>NICE</button>
        <button onClick={() => close("App23")} style={{ marginTop: "8px", height: "40px", background: "none", border: "0", color: "#8B949E", fontSize: "13px", cursor: "pointer" }}>See the new week</button>
      </div>
    </div>
  );
}
